export default __webpack_public_path__ + "static/2442-91fcf5f26bb36fac567d783766ae5ca5.gif";